import React from 'react';
import { BaseInput } from './BaseInput';

interface InputProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: 'text' | 'password' | 'email' | 'url';
  required?: boolean;
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
  helpText?: string;
}

export const Input: React.FC<InputProps> = (props) => {
  return <BaseInput {...props} />;
};